"use strict";

$(function() {
    const agbChangeListener = function(element) {
        element.parents('form').find('button[type="submit"]').prop('disabled', !element.is(':checked'));
    };

    $('#contact-form').find('input[type="checkbox"][name="agb"]').on('change', function() {
        agbChangeListener($(this));
    });

    agbChangeListener($('#contact-form').find('input[type="checkbox"][name="agb"]'));
});
